import React from 'react';

const TermosDeServico: React.FC = () => {
    return (
        <div className="relative flex min-h-screen w-full flex-col items-center bg-[#f7f9fc] dark:bg-[#101922] font-sans">
            <main className="w-full max-w-4xl flex-1 px-4 sm:px-6 lg:px-8 py-8 md:py-12">
                <div className="rounded-xl border border-gray-200 dark:border-gray-700/50 bg-white dark:bg-background-dark p-6 sm:p-8 shadow-sm">
                    <h1 className="text-[#333333] dark:text-white text-4xl font-black leading-tight tracking-[-0.033em] mb-6">
                        Termos de Serviço
                    </h1>

                    <div className="space-y-6 text-[#666666] dark:text-[#9dabb9]">
                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">1. Aceitação dos Termos</h2>
                            <p className="leading-relaxed">
                                Ao acessar e usar este serviço, você aceita e concorda em ficar vinculado aos termos e condições deste acordo.
                                Se você não concordar com qualquer parte destes termos, não deverá usar nosso serviço.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">2. Descrição do Serviço</h2>
                            <p className="leading-relaxed">
                                Nossa plataforma oferece ferramentas para otimização de orçamentos de construção, incluindo importação de arquivos BIM,
                                geração de relatórios e análise de projetos. O serviço está disponível mediante assinatura de planos ou compra de créditos.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">3. Cadastro e Conta de Usuário</h2>
                            <p className="leading-relaxed mb-2">
                                Para utilizar nossos serviços, você deve:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Fornecer informações verdadeiras, precisas e completas durante o cadastro</li>
                                <li>Manter a segurança de sua senha e conta</li>
                                <li>Notificar-nos imediatamente sobre qualquer uso não autorizado de sua conta</li>
                                <li>Ser responsável por todas as atividades que ocorram em sua conta</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">4. Planos e Pagamentos</h2>
                            <p className="leading-relaxed mb-2">
                                Os planos de assinatura são cobrados mensalmente. Os créditos avulsos têm validade conforme especificado no momento da compra.
                                Todas as cobranças são processadas de forma segura através de nossos parceiros de pagamento.
                            </p>
                            <p className="leading-relaxed">
                                O cancelamento de assinatura pode ser feito a qualquer momento, mas não haverá reembolso proporcional do período já pago.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">5. Uso Aceitável</h2>
                            <p className="leading-relaxed mb-2">
                                Você concorda em não:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Usar o serviço para qualquer finalidade ilegal ou não autorizada</li>
                                <li>Tentar obter acesso não autorizado a qualquer parte do serviço</li>
                                <li>Interferir ou interromper o serviço ou servidores conectados ao serviço</li>
                                <li>Reproduzir, duplicar, copiar ou revender qualquer parte do serviço sem permissão expressa</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">6. Propriedade Intelectual</h2>
                            <p className="leading-relaxed">
                                Todo o conteúdo, recursos e funcionalidades do serviço são de propriedade exclusiva da empresa e são protegidos
                                por leis de direitos autorais, marcas registradas e outras leis de propriedade intelectual.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">7. Limitação de Responsabilidade</h2>
                            <p className="leading-relaxed">
                                O serviço é fornecido "como está" e "conforme disponível". Não garantimos que o serviço será ininterrupto,
                                seguro ou livre de erros. Em nenhuma circunstância seremos responsáveis por quaisquer danos indiretos,
                                incidentais, especiais ou consequenciais.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">8. Modificações dos Termos</h2>
                            <p className="leading-relaxed">
                                Reservamo-nos o direito de modificar estes termos a qualquer momento. Notificaremos os usuários sobre
                                mudanças significativas por e-mail ou através de um aviso em nosso serviço. O uso continuado do serviço
                                após tais modificações constitui sua aceitação dos novos termos.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">9. Rescisão</h2>
                            <p className="leading-relaxed">
                                Podemos rescindir ou suspender seu acesso ao serviço imediatamente, sem aviso prévio ou responsabilidade,
                                por qualquer motivo, incluindo, sem limitação, se você violar os Termos de Serviço.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">10. Lei Aplicável</h2>
                            <p className="leading-relaxed">
                                Estes Termos serão regidos e interpretados de acordo com as leis do Brasil, sem considerar suas
                                disposições sobre conflitos de leis.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">11. Contato</h2>
                            <p className="leading-relaxed">
                                Se você tiver alguma dúvida sobre estes Termos de Serviço, entre em contato conosco através dos
                                canais de suporte disponíveis em nossa plataforma.
                            </p>
                        </section>

                        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
                            <p className="text-sm text-center">
                                Última atualização: {new Date().toLocaleDateString('pt-BR')}
                            </p>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default TermosDeServico;
